/**
 * Kind-level label for surfaces that must name a thing before its concrete
 * type is decided (e.g. the builder create path, where the agent hasn't yet
 * chosen between `ahoy_event_automation` and `ahoy_scheduled_automation`).
 *
 * Returns `undefined` for kinds with no such ambiguity, so callers fall back
 * to the concrete type label. Only `automation` is mapped today — it's the
 * only builder type with an event-vs-scheduled ambiguity; other kinds (e.g.
 * validation rules, kind `default`) intentionally return `undefined`.
 */
const KIND_LEVEL_LABELS: Record<string, string> = {
  automation: 'Automation',
};

export function getEntityKindLabel(
  entityKind: readonly string[] | undefined
): string | undefined {
  if (!entityKind) {
    return undefined;
  }
  for (const kind of entityKind) {
    const label = KIND_LEVEL_LABELS[kind];
    if (label) {
      return label;
    }
  }
  return undefined;
}
